module.exports = __webpack_public_path__ + "img/bg11.84bdbef6.jpg";